import store from "../store";
import Pusher from 'pusher-js';

let pusher = null;
const isDev = process.env.NODE_ENV !== 'production';
const channels = {};
const actions = {};

const presetActions = {
  account: {},
  market: {},
  user: {},
  record: {},
  activeContact: {},
  upNext: {},
  comms: {},
  webhook: {
    'webhook.created' (payload) {
      store.commit('pushWebhooks', payload.data);
    },
    'webhook.updated' (payload) {
      store.commit('updateWebhook', payload.data);
    },
    'webhook.deleted' (payload) {
      store.commit('removeWebhook', payload.data);
    },
    'webhook_submission.created' (payload) {
      store.commit('unshiftWebhookSubmission', payload.data);
    },
  },
  imports: {
    'import.created' (payload) {
      store.commit('pushImports', payload.data);
    },
    'import.updated' (payload) {
      store.commit('updateImport', payload.data);
    },
    'import.deleted' (payload) {
      store.commit('removeImport', payload.data);
    },
  },
};

const subscribeToChannel = (clientStore, storeId) => {
  const channel = clientStore + '.' + storeId;
  if (isDev) console.log('Subscribing to Pusher Channel: ' + channel);
  channels[channel] = pusher.subscribe(channel);

  if (clientStore) {
    actions[channel] = presetActions[clientStore];
  }

  // listen to all event for subscribed channel
  channels[channel].bind_global((event, payload) => {
    // Ignore Pusher Success Events
    if (event === 'pusher:subscription_succeeded') {
      if (isDev) {
        console.log(`${event} for channel ${channel}`);
      }

      return;
    }

    // allows us to override the presetActions
    if (actions[channel] !== undefined && actions[channel][event]) {
      if (isDev) console.log(`Channel ${channel}: ${event}`, payload);
      actions[channel][event](payload);
    } else if (event === 'event') {
      if (isDev) console.log(`Channel ${channel}: ${event}`, payload);
      store.dispatch('pusherEvent', payload.data);
    } else if (isDev) {
      console.error(`No callback for ${event} from channel ${channel}`, payload);
    }
  });
};

const joinPresenceChannel = (channelName, channelId) => {
  const presence = Echo.join(channelName + '.' + channelId);

  if(presence) {
    console.log('joined ' + channelName + '.' + channelId);
  }

  return presence;
};

const leavePresenceChannel = (channelName, channelId) => {
  Echo.leave(channelName + '.' + channelId);

  console.log('left ' + channelName + '.' + channelId);
}

const unsubscribeToChannel = (store, storeId) => {
  const channel = store + '.' + storeId;
  if (isDev) console.log(`Unsubscribed to channel: ${channel}`);
  pusher.unsubscribe(channel);
  delete channels[channel];
};

const setPusherAction = (channel, event, action) => {
  actions[channel][event] = action;
};

const unsubscribeToAllChannels = () => {
  for (let channel in channels) {
    unsubscribeToChannel(...channel.split('.'));
  }
};

const initPusher = () => {
  pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
    cluster: 'us2',
    forceTLS: true,
  });

  subscribeToChannel('account', store.getters.account.id);
  subscribeToChannel('market', store.getters.market.id);
  subscribeToChannel('user', store.getters.authUser.id);
};

export {
  initPusher,
  subscribeToChannel,
  unsubscribeToChannel,
  joinPresenceChannel,
  leavePresenceChannel,
  setPusherAction,
  unsubscribeToAllChannels
};
